'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Clinics = require('@vezeeta/enterprise-utils/lib/Clinics');

var _Clinics2 = _interopRequireDefault(_Clinics);

var _clinics = require('../actions/clinics');

var _enum = require('../enum');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  Clinics: [],
  loaded: false,
  loading: false,
  rooms: [],
  branches: [],
  doctors: [],
  entities: [],
  entitiesKeys: [],
  entitiesNames: new Map(),
  branchesNames: new Map(),
  roomsNames: new Map(),
  doctorsNames: new Map(),
  branchesMap: new Map(),
  branchDetailsLoadStatus: _enum.status.SHOULD_CALL_API,
  branchDetails: undefined,
  selectedBranchKey: undefined
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _clinics.BRANCH_FILTER.SET_BRANCH_KEY:
      return _extends({}, state, {
        selectedBranchKey: payload.branchKey
      });
    case _clinics.BRANCH_DETAILS.LOAD:
      return _extends({}, state, {
        branchDetailsLoadStatus: _enum.status.FETCHING
      });
    case _clinics.BRANCH_DETAILS.SUCCESS:
      return _extends({}, state, {
        branchDetails: payload,
        branchDetailsLoadStatus: _enum.status.SUCCESS
      });

    case _clinics.BRANCH_DETAILS.FAIL:
      return _extends({}, state, {
        branchDetails: payload,
        branchDetailsLoadStatus: _enum.status.FAIL
      });

    case _clinics.CLINICS.LOAD:
      return Object.assign({}, state, { loaded: false }, { loading: true });

    case _clinics.CLINICS.LOAD_DONE:
      {
        var clinicsObj = {};
        var flattenClinics = void 0;
        if (payload.clinics && payload.clinics.data) {
          clinicsObj = payload.clinics.data;
          flattenClinics = _Clinics2.default.flattenClinics(clinicsObj.Clinics);
        }

        return Object.assign({}, state, {
          Clinics: clinicsObj.Clinics,
          loaded: true,
          loading: false,
          rooms: flattenClinics.rooms,
          branches: flattenClinics.branches,
          doctors: flattenClinics.doctors,
          entities: flattenClinics.entities,
          entitiesKeys: flattenClinics.entities.map(function (entity) {
            return entity.entityKey;
          }),
          entitiesNames: flattenClinics.entitiesNames,
          branchesNames: flattenClinics.branchesNames,
          roomsNames: flattenClinics.roomsNames,
          doctorsNames: flattenClinics.doctorsNames,
          branchesMap: flattenClinics.branchesMap,
          entityImages: clinicsObj.Clinics && clinicsObj.Clinics[0] && clinicsObj.Clinics[0].EntityImages
        });
      }
    default:
      return state;
  }
};

module.exports = exports['default'];